export const RequiredRuleName = 'Required'
export const FromLessThanToRuleName = 'From'
export const ToGreaterThanFromRuleName = 'To'
export const IntersectingRangeRuleName = 'Intersecting'
export const RangeLimitRuleName = 'RangeLimit'

export const MinRangeValue = -999999
export const MaxRangeValue = 999999
